import { usePasswordForgetEmailStore } from 'src/hooks/stores'

export const usePasswordForgetEmail = () => {
  const { passwordForgetEmailStoreValue, setPasswordForgetEmailStoreValue } =
    usePasswordForgetEmailStore()

  const setPasswordForgetEmail = (email: string) => {
    setPasswordForgetEmailStoreValue(email)
  }

  return {
    forgetPasswordEmail: passwordForgetEmailStoreValue,
    setPasswordForgetEmail,
  }
}
